import React from "react";
import { Typography } from "@material-ui/core";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";

const MAX_FILES = 5;
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ACCEPTED_FILE_TYPES = "application/pdf, image/jpeg, image/png, image/tiff";

const FileUpload = ({ files, setFiles, tipoPessoa, tipoEmpresa }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    onDrop: (acceptedFiles) => {
      if (files.length >= MAX_FILES) {
        Swal.fire("Limite de Arquivos", `O limite de anexos é de ${MAX_FILES} arquivos.`);
        return;
      }

      const newFiles = acceptedFiles.reduce((acc, file) => {
        if (file.size > MAX_FILE_SIZE) {
          Swal.fire("Arquivo Muito Grande", `O arquivo ${file.name} excede o limite de ${MAX_FILE_SIZE/1024}MB.`);
          return acc;
        }

        if (files.some(existingFile => existingFile.originalName === file.name)) {
          Swal.fire("Arquivo Duplicado", `O arquivo ${file.name} já foi adicionado.`);
          return acc;
        }

        const ext = file.name.split(".").pop().toLowerCase();
        const newFileName = `${uuidv4()}.${ext}`;

        acc.push({
          file,
          preview: URL.createObjectURL(file),
          originalName: file.name,
          newFileName,
        });
        return acc;
      }, []);

      if (newFiles.length > 0) {
        setFiles((prevFiles) => [...prevFiles, ...newFiles].slice(0, MAX_FILES));
      }
    },
  });

  const handleDelete = (fileToDelete) => {
    setFiles((prevFiles) => prevFiles.filter(({ file }) => file !== fileToDelete));
  };

  const documentList = tipoEmpresa?.toUpperCase() === "J" ? [
    "Cópia do Contrato Social e/ou Última Alteração",
    "Comprovante de endereço do estabelecimento comercial",
    "Cópias do RG e CPF do(s) Proprietário(s) (pode ser substituído pela CNH)",
  ] : [
    "Cópia do RG",
    "Cópia do CPF",
    "Comprovante de endereço",
  ];

  return (
    <div>
      <div style={{ padding: "10px" }}>
        <Typography variant="subtitle1">Documentos necessários: </Typography>
        <ul>
        {documentList.map((doc, index) => (
          <li><Typography key={index} variant="caption">{doc}</Typography></li>
        ))}
        </ul>
      </div>
      <br />
      <div
        {...getRootProps()}
        style={{
          ...styles.dropzone,
          backgroundColor: files.length < MAX_FILES ? "#fff" : "#f8d7da",
          opacity: files.length >= MAX_FILES ? 0.5 : 1,
        }}
      >
        <input {...getInputProps()} />
        <p>Arraste e solte os arquivos aqui (PDF, JPG, PNG, TIFF), ou clique para selecionar</p>
      </div>
      <div style={styles.fileList}>
        {files.map(({ file, preview, newFileName }) => (
          <div key={newFileName} style={styles.fileItem}>
            <img src={preview} alt={file.name} style={styles.thumbnail} />
            <div style={styles.details}>
              <p><strong>{file.name}</strong></p>
              <p>{(file.size / 1024).toFixed(2)} KB</p>
            </div>
            <button onClick={() => handleDelete(file)} style={styles.deleteButton}>Excluir</button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  dropzone: {
    border: "1px dashed #aaa",
    borderRadius: "5px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
    marginBottom: "5px",
    transition: "background-color 0.3s",
    height : '250px'
  },
  fileList: {
    display: "flex",
    flexWrap: "wrap",
  },
  fileItem: {
    margin: "10px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  thumbnail: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    marginBottom: "10px",
  },
  deleteButton: {
    backgroundColor: "#ff4d4d",
    border: "none",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default FileUpload;